export default {
  lang(state) {
    return state.lang;
  },
  defaultLang(state) {
    return state.defaultLang;
  },
  supportedLangs(state) {
    return state.supportedLangs;
  },
  rtlLangs(state) {
    return state.rtlLangs;
  },
  admins_enums(state) {
    return state.admins_enums;
  },
  roles_enums(state) {
    return state.roles_enums;
  },
  category_enums(state) {
    return state.category_enums;
  },
  sub_category_enums(state) {
    return state.sub_category_enums;
  },
  color_enums(state) {
    return state.color_enums;
  },
  year_enums(state) {
    return state.year_enums;
  },
  brand_enums(state) {
    return state.brand_enums;
  },
  model_enums(state) {
    return state.model_enums;
  },
  model_included_enums(state) {
    return state.model_included_enums;
  },
  garage_enums(state) {
    return state.garage_enums;
  },
  hajj_garage_enums(state) {
    return state.hajj_garage_enums;
  },
  branch_enums(state) {
    return state.branch_enums;
  },
  provider_enums(state) {
    return state.provider_enums;
  },
  features_enums(state) {
    return state.features_enums;
  },
  license_type_enums(state) {
    return state.license_type_enums;
  },
  language_enums(state) {
    return state.language_enums;
  },
  nationality_enums(state) {
    return state.nationality_enums;
  },
  drivers_available_nationality_enums(state) {
    return state.drivers_available_nationality_enums;
  },
  driver_list_enums(state) {
    return state.driver_list_enums;
  },
  clients_list_enums(state) {
    return state.clients_list_enums;
  },
  services_type_list_enums(state) {
    return state.services_type_list_enums;
  },
  city_enums(state) {
    return state.city_enums;
  },
  damage_level_enums(state) {
    return state.damage_level_enums;
  },
  damage_area_enums(state) {
    return state.damage_area_enums;
  },
  body_damage_area_enums(state) {
    return state.body_damage_area_enums;
  },
  active_roles_enums(state) {
    return state.active_roles_enums;
  },
  user_info(state) {
    return state.user_info;
  },
  user_info_loaded(state) {
    return state.user_info_loaded;
  },
  client_info(state) {
    return state.client_info;
  },
  missing_part_items(state) {
    return state.missing_part_items;
  },
  is_not_permitted(state) {
    return function (permissionKey) {
      return !state.user_info?.permissions?.includes(permissionKey);
    };
  },
  companies_enums(state) {
    return state.companies_enums;
  },
  insurance_company_enums(state) {
    return state.insurance_company_enums;
  },
  regions_enums(state) {
    return state.regions_enums;
  },
  provinces_enums(state) {
    return state.provinces_enums;
  },
  zone_enums(state) {
    return state.zone_enums;
  },
  pos_enums(state) {
    return state.pos_enums;
  },
  mobile_enums(state) {
    return state.mobile_enums;
  },
  services_enums(state) {
    return state.services_enums;
  },
  driver_availability(state) {
    return state.driver_availability;
  },
  vehicle_availability(state) {
    return state.vehicle_availability;
  },
  promo_code_enums(state) {
    return state.promo_code_enums;
  },
  LTA_enums(state) {
    return state.LTA_enums;
  },
  clientType_enums(state) {
    return state.clientType_enums;
  },
  account_enums(state) {
    return state.account_enums;
  },
  proforma_invoice_enums(state) {
    return state.proforma_invoice_enums;
  },
  JV_enums(state) {
    return state.JV_enums;
  },
  reservation_list_enums(state) {
    return state.reservation_list_enums;
  },
  remote_finance_account_enums(state) {
    return state.remote_finance_account_enums;
  },
  tax_type_enums(state) {
    return state.tax_type_enums;
  },
  tax_type_zoho_enums(state) {
    return state.tax_type_zoho_enums;
  },
  operator(state) {
    return state.operator;
  },
  training_type_enums(state) {
    return state.training_type_enums;
  },
  tax_type_odoo_enums(state) {
    return state.tax_type_odoo_enums;
  },
  odoo_remote_finance_account_enums(state) {
    return state.odoo_remote_finance_account_enums;
  },
  product_enums(state) {
    return state.product_enums;
  },
  pricing_lists_enums (state) {
    return state.pricing_lists_enums;
  },
  hajj_season_year_enums(state) {
    return state.hajj_season_year_enums;
  },
  tga_type_enums(state) {
    return state.tga_type_enums;
  },
  religion_enums(state) {
    return state.religion_enums;
  },
  client_grade_enums(state) {
    return state.client_grade_enums;
  },
  reservation_category_enums(state) {
    return state.reservation_category_enums;
  },
  service_category_enums(state) {
    return state.service_category_enums;
  },
  contract_type_enums(state) {
    return state.contract_type_enums;
  },
  driver_username_enums(state) {
    return state.driver_username_enums;
  },
  client_username_enums(state) {
    return state.client_username_enums;
  },
  resource_request_username_enums(state) {
    return state.resource_request_username_enums;
  },
  user_enums(state) {
    return state.user_enums;
  },
  missing_request_payload(state) {
    return state.missing_request_payload;
  },
  vehicle_type_enums(state) {
    return state.vehicle_type_enums;
  },
  blanket_order_enums(state) {
    return state.blanket_order_enums;
  },
  kpi_reason_enums(state) {
    return state.kpi_reason_enums;
  },
  client_city_enums(state) {
    return state.client_city_enums;
  },
  client_country_enums(state) {
    return state.client_country_enums;
  },
  show_toaster_pop(state) {
    return state.toaster_message;
  },
  available_reservation_list_enums(state) {
    return state.available_reservation_list_enums;
  },
  change_password_token(state) {
    return state.change_password_token;
  },
  shift_type_enums(state) {
    return state.shift_type_enums;
  },
  driver_employee_id_list_enums(state) {
    return state.driver_employee_id_list_enums;
  },
  contract_id_enums(state) {
    return state.contract_id_enums;
  },
  contract_id_client_enums(state) {
    return state.contract_id_client_enums;
  },
  payment_method_enums(state) {
    return state.payment_method_enums;
  },
  client_contact_person_enums(state) {
    return state.client_contact_person_enums;
  },
  entity_enums(state) {
    return state.entity_enums;
  },
  username_enums(state) {
    return state.username_enums;
  },
  admin_configuration_enums(state) {
    return state.admin_configuration_enums;
  },
  driver_employee_id_enums(state) {
    return state.driver_employee_id_enums;
  },
  routes_enums(state) {
    return state.routes_enums;
  },
  workflow_enums(state) {
    return state.workflow_enums;
  },
  proforma_invoice_number_enums(state) {
    return state.proforma_invoice_number_enums;
  },
  user_name_enums(state) {
    return state.user_name_enums;
  }
};
